
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiButtonData as ObcPoiButtonDataElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-button-data/poi-button-data.js';
 
 
 

 
 export const ObcPoiButtonData = createComponent({
   react: React,
   tagName: 'obc-poi-button-data',
   elementClass: ObcPoiButtonDataElement,
   events: {
     
   }
  });
 
 